import { useQuery } from "@tanstack/react-query";
import { getTransactionsByUserId } from "services/apiTransactions";

export function useTransactions() {
  const {
    isLoading,
    data: transactions,
    error,
  } = useQuery({
    queryKey: ["transactions"],
    queryFn: () => getTransactionsByUserId(),
  });

  return { isLoading, transactions, error };
}
